<div class="row factory-quote-container">
  <div class="col-lg-1"></div>
  <div class="col-lg-10 paddingZero" [formGroup]="factoryQuoteRequest">
    <div class="row col-lg-12 paddingZero">
      <div class="col-lg-5 col-md-6 paddingZero customerStyle">
        <label>
          <span><strong>{{factoryQuoteTxt.customerNameLbl?factoryQuoteTxt.customerNameLbl:factoryQuote.customerNameLbl}}</strong> {{factoryQuote.customerNameText}} </span>
        </label>

      </div>
      <div class="col-lg-4 col-md-3 paddingZero customerStyle">
        <label>
          <span><strong>{{factoryQuoteTxt.customerNumberLbl?factoryQuoteTxt.customerNumberLbl:factoryQuote.customerNumberLbl}}</strong> {{factoryQuote.customerNumberText}} </span>
        </label>
      </div>
      <div class="col-lg-3 col-md-3 paddingZero customerStyle">
        <label>
          <span><strong>{{factoryQuoteTxt.originDateLbl?factoryQuoteTxt.originDateLbl:factoryQuote.originDateLbl}}</strong> {{factoryQuote.originDateText|date}} </span>
        </label>
      </div>
    </div>

    <div class="row col-lg-12 topCls paddingZero">
      <div class="col-lg-6 col-md-6 paddingZero">
        <label class="lbl" [for]="requestDateLbl">{{factoryQuoteTxt.quoteRequestDateLbl?factoryQuoteTxt.quoteRequestDateLbl:factoryQuote.quoteRequestDateLbl}} </label>
        <kendo-datepicker class="kendoInput" formControlName="quoteRequestDate" placeholder="MM/DD/YYYY"
                          #requestDateLbl format="MM/dd/yyyy"
                          [formatPlaceholder]="{year: 'YYYY', month: 'MM', day: 'DD'}"
                          [min]="minDate">
        </kendo-datepicker>
      </div>

    </div>
    <div class="confirmation paddingZero">
      <p>
        {{factoryQuoteTxt.emailConfirmationLbl?factoryQuoteTxt.emailConfirmationLbl:factoryQuote.emailConfirmationLbl}}
        <kendo-switch formControlName="isReceiveEmail" name="toggle" onLabel="Yes" offLabel="No" class=" ml-2" (click)="showEmail()">
        </kendo-switch>
      </p>
    </div>
   
    <div class="row col-lg-12 col-md-3 paddingZero" *ngIf="factoryQuote.isReceiveEmailChecked">
      <div class="col-lg-6 col-md-6 paddingZero">
        <label class="lbl_height" [for]="emailLbl">{{factoryQuoteTxt.emailLbl?factoryQuoteTxt.emailLbl:factoryQuote.emailLbl}} </label>

        <input type="text" kendoTextBox formControlName="email" #emailLbl class="form-control" [ngClass]="{'ng-invalid ng-touched borderRed':factoryQuote.isEmailFormatInValid}"
               (blur)="emailLeave()" />
       
        <span title="{{factoryQuoteTxt.invalidEmailLbl?factoryQuoteTxt.invalidEmailLbl:factoryQuote.invalidEmailLbl}}" *ngIf="factoryQuote.isEmailFormatInValid" kendoTooltip
              class="k-icon k-i-information k-i-info spanInfoIconCls"></span>
      </div>
      <div class="col-lg-6 col-md-6 paddingZero">
        <label class="lbl_height" [for]="confirmEmailLbl">{{factoryQuoteTxt.confirmEmailLbl?factoryQuoteTxt.confirmEmailLbl:factoryQuote.confirmEmailLbl}} </label>

        <input type="text" kendoTextBox formControlName="confirmEmail" #confirmEmailLbl class="form-control" [ngClass]="{'ng-invalid ng-touched borderRed':factoryQuote.isInvalidConfirmEmail}"
               (blur)="confirmEmailLeave()" />  
        <span title="{{factoryQuoteTxt.confirmEmailMatchLbl?factoryQuoteTxt.confirmEmailMatchLbl:factoryQuote.confirmEmailMatchLbl}}" *ngIf="factoryQuote.isemailNotMatched" kendoTooltip
              class="k-icon k-i-information k-i-info spanInfoIconCls"></span>
      </div>
    </div>
    <div class="row col-lg-12 paddingZero">
      <div class="col-lg-6 col-md-6 paddingZero">
        <label class="lbl" [for]="contactNameLbl">{{factoryQuoteTxt.contactNameLbl?factoryQuoteTxt.contactNameLbl:factoryQuote.contactNameLbl}} </label>
        <input type="text" kendoTextBox formControlName="contactName" #contactNameLbl class="kendoInput" />
      </div>
      <div class="col-lg-6 col-md-6 paddingZero">
        <label class="lbl" [for]="jobNameLbl">{{factoryQuoteTxt.jobNameLbl?factoryQuoteTxt.jobNameLbl:factoryQuote.jobNameLbl}} </label>
        <input type="text" kendoTextBox formControlName="jobName" #jobNameLbl class="kendoInput" />
      </div>
    </div>
    <div class="row col-lg-12 paddingZero">
      <div class="col-lg-3 col-md-3 paddingZero">
        <label class="lbl" [for]="productTypeLbl">{{factoryQuoteTxt.productTypeLbl?factoryQuoteTxt.productTypeLbl:factoryQuote.productTypeLbl}} </label>
        <kendo-dropdownlist class="kendoInput" #productTypeLbl formControlName="productType" [defaultItem]="defaultItem" [data]="getProductType"
                            (selectionChange)="selectProductType($event)" textField="name" valueField="value">
        </kendo-dropdownlist>
      </div>

      <div class="col-lg-3 col-md-3 paddingZero">
        <label class="lbl" [for]="finishTypeLbl">{{factoryQuoteTxt.finishTypeLbl?factoryQuoteTxt.finishTypeLbl:factoryQuote.finishTypeLbl}} </label>
        <kendo-dropdownlist class="kendoInput" #finishTypeLbl formControlName="finishType" [defaultItem]="defaultItem" [data]="getFinishType"
                            textField="name" (selectionChange)="selectFinishType($event)" valueField="value">
        </kendo-dropdownlist>
      </div>
      <!-- *ngIf="isFinishTypeSelected"-->
      <div class="col-lg-3 col-md-3 paddingZero" *ngIf="isFinishTypeSelected">
        <label class="lbl" [for]="colorLbl">{{factoryQuoteTxt.colorLbl?factoryQuoteTxt.colorLbl:factoryQuote.colorLbl}} </label>
        <kendo-dropdownlist [data]="getColor" [defaultItem]="defaultItem" formControlName="color" #colorLbl textField="name" (selectionChange)="selectPaintColor($event)"
                            class="kendoInput" valueField="value">
        </kendo-dropdownlist>
      </div>
      <!--*ngIf="isAnodizeFinishTypeSelected"-->
      <div class="col-lg-3 col-md-3 paddingZero" *ngIf="isAnodizeFinishTypeSelected">
        <label class="lbl" [for]="anodizeColorLbl">{{factoryQuoteTxt.anodizeColorLbl?factoryQuoteTxt.anodizeColorLbl:factoryQuote.anodizeColorLbl}}</label>
        <kendo-dropdownlist class="kendoInput" #anodizeColorLbl [defaultItem]="defaultItem" formControlName="anodizeColor" [data]="getAnodizeColor"
                            textField="name" valueField="value">
        </kendo-dropdownlist>
      </div>
      <!-- *ngIf="isPaint22ColorSelected"-->
      <div class="col-lg-3 col-md-3 paddingZero" *ngIf="isPaint22ColorSelected">
        <label class="lbl" [for]="paintFinishLbl">{{factoryQuoteTxt.paintFinishLbl?factoryQuoteTxt.paintFinishLbl:factoryQuote.paintFinishLbl}} </label>
        <kendo-dropdownlist [data]="getPaintFinish" [defaultItem]="defaultItem" formControlName="paintFinishDropDown" #paintFinishLbl
                            class="kendoInput" textField="name" valueField="value"></kendo-dropdownlist>
      </div>
      <!--*ngIf="isPaintOtherColorSelected"-->

      <div class="col-lg-3 col-md-3 paddingZero" *ngIf="isPaintOtherColorSelected">
        <label class="lbl" [for]="paintFinishLbl">{{factoryQuoteTxt.paintFinishInputLbl?factoryQuoteTxt.paintFinishInputLbl:factoryQuote.paintFinishInputLbl}}</label>
        <input type="text" kendoTextBox formControlName="paintFinishInput" #paintFinishLbl class="kendoInput" />
      </div>
    </div>

    <div class="row col-lg-12 paddingZero">
      <div class="col-lg-3 col-md-3 paddingZero">
        <label class="lbl" [for]="infillLbl">{{factoryQuoteTxt.infillLbl?factoryQuoteTxt.infillLbl:factoryQuote.infillLbl}} </label>
        <kendo-dropdownlist class="kendoInput" #infillLbl [defaultItem]="defaultItem" formControlName="infill" [data]="getInfill"
                            textField="name" valueField="value">
        </kendo-dropdownlist>
      </div>
      <div class="col-lg-3 col-md-3 paddingZero">
        <label class="lbl" [for]="glazingLbl">{{factoryQuoteTxt.glazingLbl?factoryQuoteTxt.glazingLbl:factoryQuote.glazingLbl}} </label>
        <kendo-dropdownlist class="kendoInput" #glazingLbl formControlName="glazing" [defaultItem]="defaultItem" [data]="getGlazing"
                            (selectionChange)="selectGlazing($event)" textField="name" valueField="value">
        </kendo-dropdownlist>
      </div>


      <div class="col-lg-3 col-md-3 paddingZero" *ngIf="isGlazedSelected">
        <!-- *ngIf="isGlazedSelected"-->

        <label class="lbl" [for]="glassSupplierLbl">{{factoryQuoteTxt.glassSupplierLbl?factoryQuoteTxt.glassSupplierLbl:factoryQuote.glassSupplierLbl}} </label>
        <kendo-dropdownlist [data]="getGlassSupplier" formControlName="glassSupplier" [defaultItem]="defaultItem" #glassSupplierLbl
                            (selectionChange)="selectGlassSupplier($event)" class="kendoInput" textField="name" valueField="value"></kendo-dropdownlist>
      </div>
      <!-- *ngIf="isGlassSupplierSelected"-->

      <div class="col-lg-3 col-md-3 paddingZero" *ngIf="isGlassSupplierSelected">
        <label class="lbl" [for]="glassSpecMakeupLbl">{{factoryQuoteTxt.glassSpecMakeupLbl?factoryQuoteTxt.glassSpecMakeupLbl:factoryQuote.glassSpecMakeupLbl}}</label>
        <input formControlName="glassSpecMakeup" #glassSpecMakeupLbl class="kendoInput" kendoTextBox />
      </div>
    </div>
    <div class="row col-lg-12 paddingZero">
      <div class="col-lg-6 col-md-6 paddingZero">
        <label class="lbl" [for]="windloadLbl">{{factoryQuoteTxt.windloadLbl?factoryQuoteTxt.windloadLbl:factoryQuote.windloadLbl}} </label>
        <input type="text" kendoTextBox formControlName="windload" #windloadLbl class="kendoInput" />
      </div>
      <div class="col-lg-6 col-md-6 paddingZero">
        <label class="lbl" [for]="muntinsLbl">{{factoryQuoteTxt.muntinsLbl?factoryQuoteTxt.muntinsLbl:factoryQuote.muntinsLbl}} </label>
        <kendo-dropdownlist class="kendoInput" #muntinsLbl formControlName="muntins" [defaultItem]="MutinsDefaultValue" [data]="getMuntins"
                            textField="name" valueField="value">
        </kendo-dropdownlist>
      </div>

    </div>
    <div class="row col-lg-12 paddingZero">
      <!--*ngIf="isProductTypeSelected"-->
      <div class="col-lg-3 col-md-3 paddingZero" *ngIf="isProductTypeSelected">
        <label class="lbl" [for]="screensLbl">{{factoryQuoteTxt.screensLbl?factoryQuoteTxt.screensLbl:factoryQuote.screensLbl}}</label>
        <kendo-dropdownlist [data]="getScreens" [defaultItem]="getScreens[0]" textField="name" formControlName="screens" #screensLbl
                            class="kendoInput" (selectionChange)="selectScreens($event)" valueField="value"></kendo-dropdownlist>
      </div>
      <!--*ngIf="isScreensSelected"-->

      <div class="col-lg-3 col-md-3 paddingZero" *ngIf="isScreensSelected">
        <label class="lbl" [for]="meshLbl">{{factoryQuoteTxt.meshLbl?factoryQuoteTxt.meshLbl:factoryQuote.meshLbl}}</label>
        <kendo-dropdownlist [data]="getMesh" formControlName="mesh" [defaultItem]="defaultItem" #meshLbl textField="name" class="kendoInput"
                            (selectionChange)="selectMesh($event)" valueField="value"></kendo-dropdownlist>
      </div>
      <!--*ngIf="isMeshSelected"-->
      <div class="col-lg-6 col-md-6 paddingZero" *ngIf="isMeshSelected">
        <label class="lbl" [for]="specifyMeshTypeLbl">{{factoryQuoteTxt.meshTypeLbl?factoryQuoteTxt.meshTypeLbl:factoryQuote.meshTypeLbl}}</label>
        <input type="text" kendoTextBox formControlName="specifyMeshType" #specifyMeshTypeLbl class="kendoInput" />
      </div>
    </div>

    <div class="row col-lg-12 paddingZero">
      <!--*ngIf="isProductTypeSelected"-->

      <div class="col-lg-3 col-md-3 paddingZero" *ngIf="isProductTypeSelected">
        <label class="lbl" [for]="hardwareLbl">{{factoryQuoteTxt.hardwareLbl?factoryQuoteTxt.hardwareLbl:factoryQuote.hardwareLbl}}</label>
        <kendo-dropdownlist class="kendoInput" #hardwareLbl formControlName="hardware" [defaultItem]="defaultItem" [data]="getHardware"
                            textField="name" (selectionChange)="selectHardware($event)" valueField="value">
        </kendo-dropdownlist>
      </div>
      <!--*ngIf="isHardwareOptionalInputSelected"-->

      <div class="col-lg-3 col-md-3 paddingZero" *ngIf="isHardwareOptionalInputSelected">
        <label class="lbl" [for]="specialFeaturesLbl">{{factoryQuoteTxt.specialFeaturesLbl?factoryQuoteTxt.specialFeaturesLbl:factoryQuote.specialFeaturesLbl}}</label>
        <input type="text" kendoTextBox formControlName="specialFeatures" #specialFeaturesLbl class="kendoInput" />
      </div>
      <!--*ngIf="isHardwareSelected"-->

      <div class="col-lg-3 col-md-3 paddingZero" *ngIf="isHardwareSelected">
        <label class="lbl" [for]="specifyHardwareLbl">{{factoryQuoteTxt.specifyHardwareLbl?factoryQuoteTxt.specifyHardwareLbl:factoryQuote.specifyHardwareLbl}}</label>
        <input type="text" kendoTextBox formControlName="specifyHardware" #specifyHardwareLbl class="kendoInput" />
      </div>
    </div>

    <div class="row col-lg-12 paddingZero" *ngIf="isProductTypeSelected">
      <div class="col-lg-12 paddingZero">
        <div class="productTypeDescription">
          {{factoryQuote.productTypeDescription}}
        </div>
      </div>
    </div>
    <div class="row col-lg-12 paddingZero">

      <div class="col-lg-4 col-md-4 paddingZero">
        <label class="lbl" [for]="pieceReceptorLbl">{{factoryQuoteTxt.pieceReceptorLbl?factoryQuoteTxt.pieceReceptorLbl:factoryQuote.pieceReceptorLbl}} </label>
        <input type="text" kendoTextBox formControlName="pieceReceptor" #pieceReceptorLbl class="kendoInput" />
      </div>
      <div class="col-lg-4 col-md-4 paddingZero">
        <label class="lbl" [for]="sillLbl">{{factoryQuoteTxt.sillLbl?factoryQuoteTxt.sillLbl:factoryQuote.sillLbl}} </label>
        <input type="text" kendoTextBox formControlName="sill" #sillLbl class="kendoInput" />
      </div>

      <div class="col-lg-4 col-md-4 paddingZero">
        <label class="lbl" [for]="panningLbl">{{factoryQuoteTxt.panningLbl?factoryQuoteTxt.panningLbl:factoryQuote.panningLbl}} </label>
        <input type="text" kendoTextBox formControlName="panning" #panningLbl class="kendoInput" />
      </div>

    </div>
    <div class="row col-lg-12 paddingZero">
      <div class="col-lg-4 col-md-4 paddingZero">
        <label class="lbl" [for]="interiorTrimLbl">{{factoryQuoteTxt.interiorTrimLbl?factoryQuoteTxt.interiorTrimLbl:factoryQuote.interiorTrimLbl}} </label>
        <input type="text" kendoTextBox formControlName="interiorTrim" #interiorTrimLbl class="kendoInput" />

      </div>
      <div class="col-lg-4 col-md-4 paddingZero">
        <label class="lbl" [for]="mullionsLbl">{{factoryQuoteTxt.mullionsLbl?factoryQuoteTxt.mullionsLbl:factoryQuote.mullionsLbl}} </label>
        <input type="text" kendoTextBox formControlName="mullions" #mullionsLbl class="kendoInput" />
      </div>

      <div class="col-lg-4 col-md-4 paddingZero">
        <label class="lbl" [for]="miscellaneousLbl">{{factoryQuoteTxt.miscellaneousLbl?factoryQuoteTxt.miscellaneousLbl:factoryQuote.miscellaneousLbl}} </label>
        <input type="text" kendoTextBox formControlName="miscellaneous" #miscellaneousLbl class="kendoInput" />
      </div>
    </div>
    <div class="row col-lg-12 paddingZero">
      <div class="col-lg-4 col-md-4 paddingZero">
        <label class="lbl" [for]="strapAnchorsLbl">{{factoryQuoteTxt.strapAnchorsLbl?factoryQuoteTxt.strapAnchorsLbl:factoryQuote.strapAnchorsLbl}} </label>
        <input type="text" kendoTextBox formControlName="strapAnchors" #strapAnchorsLbl class="kendoInput" />

      </div>

    </div>
    <div class="row col-lg-12 ">
      <div class="col-lg-12 paddingZero ">
        <label class="lbl" [for]="projectCommentLbl">{{factoryQuoteTxt.projectCommentLbl?factoryQuoteTxt.projectCommentLbl:factoryQuote.projectCommentLbl}} </label>
        <textarea kendoTextArea #projectCommentLbl class="kendoInput commentTxtCls" formControlName="projectComment"></textarea>
      </div>
    </div>

    <div class="row col-lg-12 ">
      <div class="col-lg-12 tableAlign">
        <table>
          <tr>
            <th>{{factoryQuoteTxt.markTypeLbl?factoryQuoteTxt.markTypeLbl:factoryQuote.markTypeLbl}} </th>
            <th>{{factoryQuoteTxt.quantityLbl?factoryQuoteTxt.quantityLbl:factoryQuote.quantityLbl}} </th>
            <th>{{factoryQuoteTxt.sizeLbl?factoryQuoteTxt.sizeLbl:factoryQuote.sizeLbl}} </th>
            <th>{{factoryQuoteTxt.descriptionLbl?factoryQuoteTxt.descriptionLbl:factoryQuote.descriptionLbl}} </th>
          </tr>
          <tbody>
            <tr *ngFor="let skill of skills.controls; let i = index ; let last = last">
              <ng-container [formGroup]="skill">
                <td><input formControlName="markType" type="text" class="form-control" kendoTextBox /></td>
                <td><input formControlName="quantity" type="text" class="form-control" kendoTextBox /></td>
                <td><input formControlName="size" type="text" class="form-control" kendoTextBox /></td>
                <td><input formControlName="description" type="text" class="form-control" kendoTextBox /></td>
                <td>
                  <span class="k-icon k-i-plus" style="color: green;" *ngIf="last" (click)="addSkillButtonClick()"
                        title="{{factoryQuoteTxt.addNewTitle?factoryQuoteTxt.addNewTitle:factoryQuote.addNewTitle}}"></span>
                  <span class="k-icon k-i-minus" style="color: red;" *ngIf="i!=0" (click)="removeskill(i)"
                        title="{{factoryQuoteTxt.deleteTitle?factoryQuoteTxt.deleteTitle:factoryQuote.deleteTitle}}"></span>
                </td>
              </ng-container>
            </tr>
          </tbody>

        </table>
      </div>
    </div>




    <div class="row col-lg-12 paddingZero">
      <div class="col-lg-12">
        <label class="lbl" for="fileAttachment">{{factoryQuoteTxt.attachmentLbl?factoryQuoteTxt.attachmentLbl:factoryQuote.attachmentLbl}} </label>
        <!--<input type="file" class="k-button btn" style="width: 100%;" name="fileupload" #fileAttachment />-->
        <app-upload [multiple]="true" (fileSelect)="fileSelected($event)" [uploadFolderPath]="'TempDocs\\FactoryQuote'"
                      (uploadSuccess)="uploadSuccess($event)" (uploadComplete)="uploadComplete()"  [fileRestrictions] ="fileRestrictions" [myFiles]="myFiles"></app-upload>
      </div>

    </div>
    <!--Need to align below buttons to right-->
    <div class="col-lg-12 middle">
      <button kendoButton (click)="cancel()" [disabled]="saveInProcess">{{factoryQuoteTxt.cancelLbl?factoryQuoteTxt.cancelLbl:factoryQuote.cancelLbl}}</button>
      <button kendoButton class="m-3 clearKendoButton btn btn-success"
              (click)="factoryQuoteSubmit()" [disabled]="saveInProcess">
        {{factoryQuoteTxt.submitButtonLbl?factoryQuoteTxt.submitButtonLbl:factoryQuote.submitButtonLbl}} <kendo-loader *ngIf="saveInProcess" style="color:blue"></kendo-loader>
      </button>
      <label class="SuccessLbl" *ngIf="isSuccess">
        {{factoryQuoteTxt.submitSuccessLbl?factoryQuoteTxt.submitSuccessLbl:factoryQuote.submitSuccessLbl}} &nbsp;<span class="k-icon k-i-check-circle k-i-checkmark-circle"
                                                                                                                        style="color:green;font-weight:600"></span>
      </label>
      <label class="errorLbl" *ngIf="isFailed">
        {{factoryQuoteTxt.submitFailedLbl?factoryQuoteTxt.submitFailedLbl:factoryQuote.submitFailedLbl}} &nbsp;<span class="k-icon k-i-cancel" style="color:red;font-weight:300"></span>
      </label>
    </div>
  </div>

</div>
<section>
  <kendo-dialog title="{{factoryQuoteTxt.confirmTitleLbl?factoryQuoteTxt.confirmTitleLbl:factoryQuote.confirmTitleLbl}}" *ngIf="showCancelConfirmation" (close)="confirmCancel(false)">
    <p style="margin: 30px; text-align: center;">
      {{factoryQuoteTxt.cancelConfirmLbl?factoryQuoteTxt.cancelConfirmLbl:factoryQuote.cancelConfirmLbl}}
    </p>
    <kendo-dialog-actions>
      <button class='k-button' (click)="confirmCancel(false)">
        {{factoryQuoteTxt.noLbl?factoryQuoteTxt.noLbl:factoryQuote.noLbl}}
      </button>
      <button class='k-button k-primary' (click)="confirmCancel(true)" primary="true">
        {{factoryQuoteTxt.yesLbl?factoryQuoteTxt.yesLbl:factoryQuote.yesLbl}}
      </button>
    </kendo-dialog-actions>
  </kendo-dialog>
  <div class="k-overlay" *ngIf="confirmWindowOpened"></div>
  <kendo-window [minWidth]="200" [minHeight]="125" title="{{factoryQuoteTxt.quoteSubmittedLbl?factoryQuoteTxt.quoteSubmittedLbl:factoryQuote.quoteSubmittedLbl}}" *ngIf="confirmWindowOpened" (close)="confirmWindowClose()">
    <!--<p style="text-align: center;">Additional info</p>-->
    <div>
      {{factoryQuoteTxt.submittedForProcessingLbl?factoryQuoteTxt.submittedForProcessingLbl:factoryQuote.submittedForProcessingLbl}}
      <br />
      {{factoryQuoteTxt.thanksLbl?factoryQuoteTxt.thanksLbl:factoryQuote.thanksLbl}}
      <br /><br />
            <div>{{factoryQuoteTxt.actioneNeededLbl?factoryQuoteTxt.actioneNeededLbl:factoryQuote.actioneNeededLbl}}</div>
      <br /><br />
      <div>
        <strong>{{factoryQuoteTxt.contactInfoLbl?factoryQuoteTxt.contactInfoLbl:factoryQuote.contactInfoLbl}}</strong>: <span>{{factoryQuoteTxt.emailLbl?factoryQuoteTxt.emailLbl:factoryQuote.emailLbl}}: {{factoryQuote.responseEmail}}</span>
      </div>
      <br>
      <a [routerLink]="['/manage-quote/in-house-quote']">{{factoryQuoteTxt.returnToInHouseQuoteLbl?factoryQuoteTxt.returnToInHouseQuoteLbl:factoryQuote.returnToInHouseQuoteLbl}}</a>
      &nbsp;|&nbsp;
      <a [routerLink]="['/manage-quote/request-quote']">{{factoryQuoteTxt.addNewQuoteRequestLbl?factoryQuoteTxt.addNewQuoteRequestLbl:factoryQuote.addNewQuoteRequestLbl}}</a>

    </div>
  </kendo-window>
</section>
